export default __webpack_public_path__ + "static/media/vintage65g-5.0adfe157.jpg";